export default __webpack_public_path__ + "static/media/react-landing-page-thumb.1643eb2e.png";